/**
 * Standalone section label rendered above a Card as a lightweight heading.
 * @param props - Contains a title string and an optional DOM id used as a
 *   scroll/highlight anchor by settings search
 * @returns Section label element
 */
export function SectionLabel({ title, id }: { title: string; id?: string }) {
  return (
    <h3
      id={id}
      className="text-lg font-semibold tracking-tight pl-2 scroll-mt-24"
    >
      {title}
    </h3>
  );
}
